import { itemOf } from "./state"
import type { ProjectState, Run, WakeReason } from "./types"

/** Full wake batches determine scope; a display list truncated to ten reasons cannot prove exclusivity. */
export const projectWorkScope = (s: ProjectState, reasons: ReadonlyArray<WakeReason>): Run["workScope"] => {
  const scopes = reasons.map((reason) => {
    if (reason._tag === "project_work") {
      if (reason.phase !== "request" || reason.control) return null
      const request = s.workRequests?.find((r) => r.id === reason.requestId)
      return request ? { requestId: request.id, revision: reason.revision ?? request.revision } : null
    }
    if ("itemId" in reason && reason.itemId) return itemOf(s, reason.itemId)?.workRequest ?? null
    return null
  })
  const requests = [
    ...new Map(
      scopes.flatMap((scope) => (scope ? [[`${scope.requestId}:${scope.revision}`, scope] as const] : [])),
    ).values(),
  ]
  return requests.length
    ? { requests, exclusive: requests.length === 1 && scopes.every((scope) => scope !== null) }
    : undefined
}

export const servesProjectWork = (run: Run, requestId: string, revision: number): boolean =>
  run.workScope?.requests.some((scope) => scope.requestId === requestId && scope.revision <= revision) ??
  false
